class SavingsHeaderAndControlsComponentCtrl {
  static bindings = {
    allIn: '<',
    allOut: '<',
    account: '<',
    activeSellerTierType: '<',
    featureList: '<',
    isOptAllInDisabled: '<', // buyer
    setAllIn: '&', // buyer
    loadScenario: '&', // seller
    usePrimaryEquivalentCrosses: '<'
  };

  activeSellerTierType: string;
  isOptAllInDisabled = true; // buyer

  usePrimaryEquivalentCrosses: boolean;

  constructor() {
    'ngInject';
  }
}

export const SavingsHeaderAndControlsComponent = {
  bindings: SavingsHeaderAndControlsComponentCtrl.bindings,
  controller: SavingsHeaderAndControlsComponentCtrl,
  template: require('./savingsHeaderAndControls.component.html')
};
